import request from "app/vendor/request"
import config from "app/config"
import { getCurrentApp } from "app/api/localTools"

/*
 * 单文件的后端签名
 */
export function signFile(fileName, contentMd5) {
  const signParams = {
    contentMd5,
    filename: fileName,
    contentType: "application/octet-stream",
    method: "post",
    query: "?uploads"
  }
  return request.post(`${config.backend}/${getCurrentApp()}/qingcloud/sign`)
    .send(signParams)
    .type("application/json")
    .checkToken()
    .commonDispose()
}

export function initUpload(file, objectKey, contentMd5, appId, label, referenceCount) {
  const payload = {
    filename: file.name,
    tracer: file.tracer,
    pairedEnd: file.pairedEnd,
    paired: file.paired,
    sex: file.sex,
    sampleType: file.sampleType,
    objectKey,
    groupId: file.groupInfo.id,
    size: file.size,
    reference: file.reference,
    md5: contentMd5,
    appId,
    label,
    referenceCount
  }

  return request.post(`${config.backend}/${getCurrentApp()}/datas`)
    .send(payload)
    .checkToken()
    .commonDispose()
}

/*
 * 初始化青云的单文件上传配置
 */
export function initQingUpload(sign, contentMd5) {
  const header = {
    "Authorization": sign.Authorization,
    "x-qs-date": sign["x-qs-date"],
    "Content-MD5": contentMd5,
    "Content-Type": "application/octet-stream"
  }
  return request.post(`${config.qingstor}/${sign.filename}?uploads`)
    .set(header)
    .commonDispose()
}

/*
 * 单片的签名
 */
export function signChunk(signParams) {
  return request.post(`${config.backend}/${getCurrentApp()}/qingcloud/multisign`)
    .send(signParams)
    .checkToken()
    .commonDispose()
}

/*
 * 文件上传 put 请求
 */
export function uploadData({ chunk, query, sign, MD5, fileName }, onProgress) {
  const header = {
    "Authorization": sign.Authorization,
    "x-qs-date": sign["x-qs-date"],
    "Content-MD5": MD5,
    "Content-Type": "application/octet-stream"
  }
  return request.put(`${config.qingstor}/${fileName}${query}`)
    .send(chunk)
    .set(header)
    .on("progress", event => {
      onProgress({
        isNormal: !isNaN(event.percent),
        value: event.percent
      })
    })
    .promiseify()
    .then(res => res.body, err => { // 有一部分请求，body 即是二进制流或者 html，无法手动解析（如果是 json，也已经解析好了）
      return Promise.reject(err.body)
    })
}

/*
 * 文件上传后端确认, 附带小组信息
 */
export function confirmUpload(dataId, uploadResult = null) {
  const payload = uploadResult ? {
    objectKey: uploadResult.name, // 使用 uploadResult 中的 name
    url: uploadResult.url,
    size: uploadResult.size,
    etag: uploadResult.etag
  } : {} // 对于秒传，payload可以为空
  
  return request.put(`${config.backend}/${getCurrentApp()}/datas/${dataId}/complete`)
    .send(payload) // 将 payload 发送给后端
    .type("application/json")
    .checkToken()
    .commonDispose()
}

export function confirmBatchComplete(batchNumber) { //同一批次数据文件全部上传完成后调用 仅针对ecs
  return request.post(`${config.backend}/ecs/datas/complete/${batchNumber}`)
    .checkToken()
    .commonDispose()
}

/*
 * 向青云校验最后一片，获取单文件的上传结果
 */
export function completeFromQing(sign, filename, MD5, upload_id, chunk_order) {
  const header = {
    "Authorization": sign.Authorization,
    "x-qs-date": sign["x-qs-date"],
    "Content-Type": "application/json",
    "Content-MD5": MD5
  }

  return request.post(`${config.qingstor}/${filename}?upload_id=${upload_id}`)
    .send({ object_parts: chunk_order })
    .set(header)
    .commonDispose()
}

export function loadGroupList(appId) {
  return request.get(`${config.backend}/${getCurrentApp()}/groups?appId=${appId}`)
    .checkToken()
    .commonDispose()
}

export function searchGroups(appId, keyword) {
  return request.get(`${config.backend}/${getCurrentApp()}/groups?appId=${appId}&keywords=${keyword}`)
    .checkToken()
    .commonDispose()
}

export function createGroup(name, appId) {
  const payload = {
    name,
    appId
  }

  return request.post(`${config.backend}/${getCurrentApp()}/groups`)
    .send(payload)
    .checkToken()
    .commonDispose()
}

export function loadGroup(id) {
  return request.get(`${config.backend}/${getCurrentApp()}/family/${id}`)
    .checkToken()
    .commonDispose()
}

export function getBatchNumber() {
  return request.get(`${config.backend}/datas/batch`)
    .checkToken()
    .commonDispose()
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/tools/uploadRequest.js